export const UPDATE_NAME = 'UPDATE_NAME'    // 测试redux

// main主页面
export const ADD_TABSLIST = 'ADD_TABSLIST'  // 新增主页面tabs选项卡
export const DEL_TABSLIST = 'DEL_TABSLIST'  // 删除主页面tabs选项卡

// 全局加载动画
export const LOADING = 'LOADING'

// 角色管理页面
export const ROLE_ADD_PAGE_CONFIG = 'ROLE_ADD_PAGE_CONFIG'  // 添加角色页面配置
export const ROL_SET_PAGE_CONFIG = 'ROL_SET_PAGE_CONFIG'    // 设置角色页面配置

// 订单管理
export const ORDER_ADD_GOODS_INFO = 'ORDER_ADD_GOODS_INFO'    // 添加货品信息
export const ORDER_DEL_GOODS_INFO = 'ORDER_DEL_GOODS_INFO'    // 删除货品信息
export const ORDER_UPDATE_GOODS_INFO = 'ORDER_UPDATE_GOODS_INFO'    // 修改货品信息

// 权限（菜单、按钮）
export const ADD_MENU_LIMITS = 'ADD_MENU_LIMITS'    // 添加菜单数据
export const CLEAR_MENU_LIMITS = 'CLEAR_MENU_LIMITS'    // 清空菜单数据
export const ADD_BUTTON_LIMITS = 'ADD_BUTTON_LIMITS'    // 添加页面按钮数据
export const CLEAR_BUTTON_LIMITS = 'CLEAR_BUTTON_LIMITS'    // 清空页面按钮数据

// 首页
export const ADD_COMMON_DATA = 'ADD_COMMON_DATA'    // 常用功能
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO' // 用户数据
export const WORKBENCH_INFO = 'WORKBENCH_INFO' // 当前工作台数据